import { api } from "assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await api.get("/kam/categories", options);

  return response;
};

export const post = async (category) => {
  const response = await api.post("/kam/categories", category);

  return response;
};

export const put = async (category) => {
  const response = await api.put("/kam/categories", category);

  return response;
};
